module.exports = __webpack_public_path__ + "static/media/bannerette.dbba44d7.jpg";